<template>
    <div class="input-group date" v-bind:id="idInternal" data-target-input="nearest"> 
        <div class="input-group-prepend" :data-target="target" data-toggle="datetimepicker">
            <span class="input-group-text rounded-0" v-bind:class="calendarClass">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.6348 2.14007H15.658C15.4597 2.14007 15.2967 1.97711 15.2967 1.77873V0.701794C15.2967 0.503411 15.1373 0.340454 14.9354 0.340454H13.8549C13.6565 0.340454 13.4971 0.503411 13.4971 0.701794V1.78227C13.4971 1.98065 13.3377 2.14361 13.1357 2.14361H4.86037C4.66199 2.14361 4.49903 1.98065 4.49903 1.78227V0.701794C4.49903 0.503411 4.33962 0.340454 4.13769 0.340454H3.06076C2.86238 0.340454 2.69942 0.503411 2.69942 0.701794V1.78227C2.69942 1.98065 2.54 2.14361 2.33808 2.14361H0.361339C0.159414 2.14007 0 2.30302 0 2.50141V3.58188C0 3.78027 0.159414 3.94322 0.361339 3.94322H17.6383C17.8367 3.94322 17.9997 3.78027 17.9997 3.58188V2.50141C17.9961 2.30302 17.8367 2.14007 17.6348 2.14007Z" :fill="`#${iconColor}`"/>
                    <path d="M17.6348 5.34033H0.361339C0.162957 5.34033 0 5.49975 0 5.70167V17.5798C0 17.7782 0.159414 17.9412 0.361339 17.9412H17.6383C17.8367 17.9412 17.9997 17.7782 17.9997 17.5798V5.70167C17.9961 5.49975 17.8367 5.34033 17.6348 5.34033ZM4.49903 15.7767C4.49903 15.975 4.33962 16.138 4.13769 16.138H3.06076C2.86238 16.138 2.69942 15.975 2.69942 15.7767V14.6962C2.69942 14.4978 2.85883 14.3349 3.06076 14.3349H4.14123C4.33962 14.3349 4.50257 14.4943 4.50257 14.6962V15.7767H4.49903ZM4.49903 12.1774C4.49903 12.3758 4.33962 12.5388 4.13769 12.5388H3.06076C2.86238 12.5388 2.69942 12.3758 2.69942 12.1774V11.1005C2.69942 10.9021 2.85883 10.7392 3.06076 10.7392H4.14123C4.33962 10.7392 4.50257 10.8986 4.50257 11.1005V12.1774H4.49903ZM4.49903 8.57822C4.49903 8.7766 4.33962 8.93956 4.13769 8.93956H3.06076C2.86238 8.93956 2.69942 8.7766 2.69942 8.57822V7.49774C2.69942 7.29936 2.85883 7.1364 3.06076 7.1364H4.14123C4.33962 7.1364 4.50257 7.29582 4.50257 7.49774V8.57822H4.49903ZM8.09825 15.7767C8.09825 15.975 7.93884 16.138 7.73691 16.138H6.65998C6.4616 16.138 6.29864 15.975 6.29864 15.7767V14.6962C6.29864 14.4978 6.45806 14.3349 6.65998 14.3349H7.74046C7.93884 14.3349 8.1018 14.4943 8.1018 14.6962V15.7767H8.09825ZM8.09825 12.1774C8.09825 12.3758 7.93884 12.5388 7.73691 12.5388H6.65998C6.4616 12.5388 6.29864 12.3758 6.29864 12.1774V11.1005C6.29864 10.9021 6.45806 10.7392 6.65998 10.7392H7.74046C7.93884 10.7392 8.1018 10.8986 8.1018 11.1005V12.1774H8.09825ZM8.09825 8.57822C8.09825 8.7766 7.93884 8.93956 7.73691 8.93956H6.65998C6.4616 8.93956 6.29864 8.7766 6.29864 8.57822V7.49774C6.29864 7.29936 6.45806 7.1364 6.65998 7.1364H7.74046C7.93884 7.1364 8.1018 7.29582 8.1018 7.49774V8.57822H8.09825ZM11.6975 15.7767C11.6975 15.975 11.5381 16.138 11.3361 16.138H10.2557C10.0573 16.138 9.89432 15.975 9.89432 15.7767V14.6962C9.89432 14.4978 10.0537 14.3349 10.2557 14.3349H11.3361C11.5345 14.3349 11.6975 14.4943 11.6975 14.6962V15.7767ZM11.6975 12.1774C11.6975 12.3758 11.5381 12.5388 11.3361 12.5388H10.2557C10.0573 12.5388 9.89432 12.3758 9.89432 12.1774V11.1005C9.89432 10.9021 10.0537 10.7392 10.2557 10.7392H11.3361C11.5345 10.7392 11.6975 10.8986 11.6975 11.1005V12.1774ZM11.6975 8.57822C11.6975 8.7766 11.5381 8.93956 11.3361 8.93956H10.2557C10.0573 8.93956 9.89432 8.7766 9.89432 8.57822V7.49774C9.89432 7.29936 10.0537 7.1364 10.2557 7.1364H11.3361C11.5345 7.1364 11.6975 7.29582 11.6975 7.49774V8.57822ZM15.2967 15.7767C15.2967 15.975 15.1373 16.138 14.9354 16.138H13.8549C13.6565 16.138 13.4935 15.975 13.4935 15.7767V14.6962C13.4935 14.4978 13.653 14.3349 13.8549 14.3349H14.9354C15.1337 14.3349 15.2967 14.4943 15.2967 14.6962V15.7767ZM15.2967 12.1774C15.2967 12.3758 15.1373 12.5388 14.9354 12.5388H13.8549C13.6565 12.5388 13.4935 12.3758 13.4935 12.1774V11.1005C13.4935 10.9021 13.653 10.7392 13.8549 10.7392H14.9354C15.1337 10.7392 15.2967 10.8986 15.2967 11.1005V12.1774ZM15.2967 8.57822C15.2967 8.7766 15.1373 8.93956 14.9354 8.93956H13.8549C13.6565 8.93956 13.4935 8.7766 13.4935 8.57822V7.49774C13.4935 7.29936 13.653 7.1364 13.8549 7.1364H14.9354C15.1337 7.1364 15.2967 7.29582 15.2967 7.49774V8.57822Z" :fill="`#${iconColor}`"/>
                </svg>
            </span>
        </div>
        <input
            type="text"
            :placeholder="label"
            class="form-control datetimepicker-input rounded-0 agile-datetimepicker"
            :data-target="target"
            ref="datetimeRef"
        /> 
    </div>
</template>

<script>
import moment from "moment";
import "moment-timezone";
import { TempusDominus, Namespace, DateTime} from '@eonasdan/tempus-dominus';



export default {
    name: "DateTimeInputNative",
    props: ["active", "value", "label", "id", "minDate", "maxDate"],
    watch: {
        minDate: function(newVal, oldVal) {
            //console.log("minDate watcher ", newVal , " ", oldVal);
            if (!this.picker) return;
            this.picker.updateOptions({
                restrictions:{
                    minDate:this.minDate
                },
            });
            
        },
        maxDate: function(newVal, oldVal) {
            //console.log("maxDate watcher ", newVal , " ", oldVal);
            if (!this.picker) return;
            this.picker.updateOptions({
                restrictions:{
                    maxDate:newVal
                },
            });
        },
        value: function(newVal, oldVal){
            //console.log("value watcher ", this.value, " ", newVal , " ", oldVal, " ",  this.value === oldVal);
            if (!this.picker) return;
            if( this.value.toString() !== oldVal.toString())
                this.picker.dates.setValue(DateTime.convert(this.value));
        },
        windowWidth: function(newVal, oldVal){
            //console.log("DATETIMEPICKER ", this.label, " - Watcher " ,oldVal , " ",  newVal);
            if(newVal > 768 && oldVal <= 768){
                //console.log("   - Watcher bigger 768");
                this.picker.updateOptions({
                    display:{
                        sideBySide: true,
                    },
                });
            }else{
                //console.log("   - Watcher smaller 768");
                this.picker.updateOptions({
                    display:{
                        sideBySide: false,
                    },
                });
            }
        }
    },
    data() {
        return {
            picker: null,
            windowWidth: 0,
        };
    },
    mounted() {
        this.windowWidth = window.innerWidth;

        let timeZone = moment.tz.guess();
        var today = new Date();

        this.picker = new TempusDominus(this.$refs.datetimeRef,  {
            useCurrent: false, // important! to not use the current date
            display:{
                sideBySide: this.windowWidth > 768?true:false,
            },
            restrictions:{
                minDate:today,
                enabledHours: [6,7,8,9,10,11,12,13,14,15,16],
            },
            localization: {
                format: "dd/MM/yyyy, HH:mm",
                startOfTheWeek: 1,
            },
            stepping: 15,
        });

        
        if (this.internalValue) {
            //console.log("in mount set date ", this.internalValue);
            this.picker.dates.setValue(DateTime.convert(this.internalValue));
        };


        const subscription = this.$refs.datetimeRef.addEventListener(Namespace.events.change, (e)=>{ 
            //console.log("\n\nEvent value change ", e.detail);
            this.internalValue = e.detail.date;
        });

        // EventHanler to get resizing of the Window to set datepicker sideBySide to true or false
        const resizeObserver = new ResizeObserver(() => {
            if(this.windowWidth !== window.innerWidth){
                this.windowWidth = window.innerWidth;
            }
        });
        resizeObserver.observe(document.body);


    },
    beforeUnmount() {
        //window.removeEventListener("resize", this.sizeEventHandler);
    },
    computed: {
        calendarClass: function() {
            //return this.active ? ["bg-gray-200", "border-gray-800", "text-black"] : ["bg-white", "border-gray-300", "text-black"];
            return this.active ? ["bg-agile-black"] : ["bg-white"];
        },

        idInternal: {
            get() {
                return this.id;
            },
        },
        target: {
            get() {
                return "#" + this.idInternal;
            },
        },
        internalValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                // let timeZone = moment.tz.guess();
                // let localDateTime = newValue.clone().tz(timeZone);
                this.$emit("update-date", newValue);
            },
        },

        iconColor: function() {
            return this.active ? 'F8F8F8' : '202020';
        }
    },
    methods: {
        // EventHanler to get resizing of the Window to set datepicker sideBySide to true or false

        onChanged: function(ev) {
            console.log('ON CHANGED:::')
            console.log("CHANGED", ev.target.value);
            this.$emit("change", ev.target.value); // send date in format of https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local
        },
        onFocus: function(ev) {
            // this.active = true;
            console.log('ON FOCUS:::')
            this.$emit("focus", ev);
        },
        onBlur: function() {
            // this.active = false;
        },
    },
};
</script>

<style lang="scss">
    $fa-font-path : "~@fortawesome/fontawesome-free/webfonts";
    @import "./node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss";
    @import "./node_modules/@fortawesome/fontawesome-free/scss/solid.scss";
    @import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';

    .datetimepicker-input{
        border: 1px solid rgba(32, 32, 32, 0.5);
        border-left: 0;
    }
    .input-group-text{
        border: 1px solid rgba(32, 32, 32, 0.5);
        border-right: 0;
    }
    .agile-datetimepicker{
        font-family: 'gilroy';
        font-weight: 500;
        font-size: 14px;
    }
</style>
